var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.38 2.62462H9.8112C9.23598 2.62462 8.76966 2.15831 8.76966 1.58308V1.06193C8.76966 0.475453 8.29421 0 7.70773 0H2.12386C0.950907 0 0 0.950835 0 2.12386V19.9947L2.7251 6.73678C2.82467 6.25246 3.2509 5.90491 3.74534 5.90491H30.5038V4.74848C30.5038 3.57546 29.5529 2.62462 28.38 2.62462Z",
    fill: "#C2C9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8759 7.988H4.59458L0.49627 27.9263C0.361833 28.5805 0.861473 29.1933 1.52937 29.1933H31.9998C33.0824 29.1933 33.9917 28.379 34.1108 27.303L35.9869 10.3454C36.126 9.08761 35.1413 7.988 33.8759 7.988Z",
    fill: "#C2C9CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.65db3d19b50eb61c5a7b533a461cffec.svg";
export { ForwardRef as ReactComponent };